import C_GreyBox from './GrayBox';
import C_Alert from './Alert'
import C_GrayBox from './GrayBox';
import C_Wizard from './Wizard';
import C_CommonSignUpFooter from './CommonSignUpFooter';
import C_InProcess from './InProcess';
import * as C_SvgICons from './SVGIcons';
import C_PerfetchImages from './PerfetchImages';
import C_MarketPlaceBox from './MarketPlaceBox';

export { default as CloudTypeSelector } from './CloudTypeSelector';
export type { CloudTypeStateProps } from './CloudTypeSelector';

export const GreyBox = C_GreyBox;
export const Alert = C_Alert;
export const GrayBox = C_GrayBox;
export const Wizard = C_Wizard;
export const CommonSignUpFooter = C_CommonSignUpFooter;
export const InProcess = C_InProcess;
export const SvgICons = C_SvgICons;
export const PerfetchImages = C_PerfetchImages;
export const MarketPlaceBox = C_MarketPlaceBox;
